import React from 'react';

import FileStates from 'FileStates';
import {BioentityPopoverContent} from 'molbio/BioentityPopoverContent';
import Popover from 'ui-library/floating-ui/Popover';

export interface AntibodyComponentPopoverProps {
  proteinId: string | null;
  inaccessible: boolean;
  children: JSX.Element;
}

/**
 * Popover component for antibody domain components that shows protein metadata when provided.
 */
export default function AntibodyComponentPopover({
  proteinId,
  inaccessible,
  children,
}: AntibodyComponentPopoverProps): JSX.Element {
  return (
    <Popover
      isDisabled={proteinId == null}
      renderContent={() =>
        inaccessible ? (
          '(No access)'
        ) : (
          <BioentityPopoverContent
            id={proteinId ?? null}
            onClickName={() => {
              if (proteinId != null) {
                FileStates.get().openFolderItem(proteinId);
              }
            }}
            validationExtras={null}
          />
        )
      }
    >
      {children}
    </Popover>
  );
}
